"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.majorToMinor = exports.minorToMajor = exports.getCurrencyValue = exports.getCurrencyValueAsNumber = void 0;
function getCurrencyValueCore(options, currencyValue) {
    var currencyUnit = currencyValue.currencyUnit || currencyValue.currencyCode;
    var unit = options.unit, _a = options.abs, abs = _a === void 0 ? false : _a, ceil = options.ceil, floor = options.floor;
    var amount = parseFloat(currencyValue.amount);
    if (abs) {
        amount = Math.abs(amount);
    }
    if (currencyUnit !== unit) {
        amount =
            currencyUnit === 'GBP' && unit === 'GBX'
                ? (amount = amount * 100)
                : (amount = amount / 100); // currencyUnit must be `GBX` and unit must be `GBP`
    }
    if (floor) {
        amount = amount < 0 ? Math.ceil(amount) : Math.floor(amount);
    }
    if (ceil) {
        amount = amount < 0 ? roundAwayFromZero(amount) : Math.ceil(amount);
    }
    return amount;
}
function roundAwayFromZero(num) {
    if (num < 0) {
        var rounded = Math.ceil(Math.abs(num));
        return -rounded;
    }
    else {
        return Math.round(num);
    }
}
function removeNegativeZero(input) {
    if (parseFloat(input) === 0 && input[0] === '-') {
        return input.substr(1);
    }
    else {
        return input;
    }
}
function getCurrencyValueAsNumber(options, currencyValue) {
    return Number(getCurrencyValueCore(options, currencyValue));
}
exports.getCurrencyValueAsNumber = getCurrencyValueAsNumber;
function getCurrencyValue(options, currencyValue) {
    var dp = options.dp;
    var amount = getCurrencyValueCore(options, currencyValue);
    var result = typeof dp === 'number' ? amount.toFixed(dp) : amount.toString();
    return removeNegativeZero(result);
}
exports.getCurrencyValue = getCurrencyValue;
var minorToMajor = function (value, unitType) {
    if (unitType && unitType[unitType.length - 1].toUpperCase() !== 'X') {
        return "".concat(value); //Currency Codes ending in X are in minor units. Thus, no need to convert
    }
    if (typeof value === 'string') {
        return isNaN(parseFloat(value)) ? '' : "".concat(parseFloat(value) / 100);
    }
    return "".concat(value / 100);
};
exports.minorToMajor = minorToMajor;
var majorToMinor = function (value, unitType) {
    //Check if unit is GBX or AUX
    if (unitType && unitType[unitType.length - 1].toUpperCase() === 'X') {
        return "".concat(value); //If already minor don't convert
    }
    if (typeof value === 'string') {
        return isNaN(parseFloat(value)) ? '' : "".concat(parseFloat(value) * 100);
    }
    return "".concat(value * 100);
};
exports.majorToMinor = majorToMinor;
